import React from 'react';
import SearchField from '../../components/SearchField';

interface AdminListToolbarProps {
  search: string;
  onSearch: (value: string) => void;
  searchPlaceholder: string;
  searchAriaLabel?: string;
  /** Filter controls, rendered inline after the search field */
  children?: React.ReactNode;
  /** Primary action button(s), rendered right-aligned in their own row above the search row */
  actions?: React.ReactNode;
}

/**
 * The standard list toolbar for admin tools: action buttons in their own row
 * on top (right-aligned), search + filters below — directly above the table
 * they control. Every admin list view uses this so search/filter/action
 * placement is identical across tools.
 */
const AdminListToolbar: React.FC<AdminListToolbarProps> = ({
  search,
  onSearch,
  searchPlaceholder,
  searchAriaLabel,
  children,
  actions,
}) => {
  return (
    <div className="space-y-2">
      {actions && <div className="flex flex-wrap items-center justify-end gap-2">{actions}</div>}
      <div className="flex flex-wrap items-center gap-2">
        <SearchField
          value={search}
          onChange={onSearch}
          placeholder={searchPlaceholder}
          className="w-64"
          size="sm"
          ariaLabel={searchAriaLabel ?? searchPlaceholder}
        />
        {children}
      </div>
    </div>
  );
};

export default AdminListToolbar;
